import { EN } from "./i18n.en";

/* One site, two languages. Norwegian is the source: every UI string is written in Norwegian in the components and looked up
   here when the visitor is on /en. The language is fixed per page load from the URL, which lets the router run with
   basename="/en" so every existing <Link to="/..."> keeps working unchanged. Content from the API is translated server-side
   (`?lang=en`, see backend/translate.py). Switching language is a full navigation to the same path in the other language. */

const path = typeof window !== "undefined" ? window.location.pathname : "/";
export const LANG = path === "/en" || path.startsWith("/en/") ? "en" : "no";
export const isEn = LANG === "en";
export const LOCALE = isEn ? "en-GB" : "nb-NO";
export const BASENAME = isEn ? "/en" : "";

const missing = new Set();

/** t("Norsk tekst") → English on /en, the Norwegian itself otherwise. `{name}` placeholders are filled from `vars`. */
export const t = (s, vars) => {
  let out = s;
  if (isEn) {
    const hit = EN[s];
    if (hit === undefined) {
      if (process.env.NODE_ENV !== "production" && !missing.has(s)) { missing.add(s); console.warn("[i18n] missing:", s); }
    } else out = hit;
  }
  if (vars) for (const k of Object.keys(vars)) out = out.split(`{${k}}`).join(String(vars[k]));
  return out;
};

/** The same page in the other language – used by the EN/NO switch (full navigation, keeps path, query and hash). */
export const langHref = (lang) => {
  const { pathname, search, hash } = window.location;
  const bare = pathname.replace(/^\/en(?=\/|$)/, "") || "/";
  return (lang === "en" ? `/en${bare === "/" ? "" : bare}` : bare) + search + hash;
};

/** Absolute URL of a path in a given language (hreflang / canonical). */
export const absUrl = (pathname, lang) => `${window.location.origin}${lang === "en" ? `/en${pathname === "/" ? "" : pathname}` : pathname}`;

/** Numbers from Norwegian content ("364,9") shown in the English decimal convention. */
export const num = (v) => (isEn && typeof v === "string" ? v.replace(/(\d),(\d)/g, "$1.$2") : v);

if (typeof document !== "undefined") document.documentElement.lang = isEn ? "en" : "nb";
